var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIq(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 13.3H54v13.4H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M.7 0H54v13.3H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M.7 26.7H54V40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007a3d",
    d: "m33.2 17.6-.2-.2h.2l.8-.1.2-.2.2.1.3.1.3-.4h.1q.1.5-.3.6h-.7a1 1 0 0 1-.9 0m.9-.8-.2-.6h.2l.1.3q0 .4-.1.3m-9.9-.3.5.8h-.3c-.6.6-2.7 2.7-3 3.2l3.4-.1c0-.8.7-.8 1.2-1.1.3.4.9.4 1 1v2.5h-9.7a1.4 1.4 0 0 1-1.8 1.1q.6-.3 1-.8-.1-1.4-.7-2 .6-.2 1-.6c-.3 1 1 1 1.9 1q0-.7-.3-.9c.4-.1.4-.2 1-.6v1.4H26c0-.5.1-1.2-.2-1.2s0 .9-.3.9h-5.2v-.9l1.7-1.7zm13 0 1.1.5-.2.5v4q.6-.1.8-.4c0 .6.5 1.2.4 1.8h-2zm-2.8 2 .8-.6v3.4h.5v-3.8l.8-.8v6.1h-4.9c0-1.2 0-2.6 1.4-2.3V20l-.1-.1 1-.8v2.2h.5zm-1.8 2.8c0 .1.4.1.4-.1s-.5-.2-.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007a3d",
    d: "M18.4 23.9a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m9.2-7.4 1.1.6-.2.4v4q.6 0 .8-.4c0 .6.5 1.3.5 1.8h-2.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIq);
export default __webpack_public_path__ + "static/media/iq.d6a232f9e2177963eb3e5c1175529ce3.svg";
export { ForwardRef as ReactComponent };